import axios from "helpers/_axios";
import hasProperty from "lodash/has";
export const LOADING_WORKFLOW = "LOADING_WORKFLOW";
export const ERROR_WORKFLOW = "ERROR_WORKFLOW";
export const GET_ALL_WORKFLOWS = "GET_ALL_WORKFLOWS";
export const GET_WORKFLOW = "GET_WORKFLOW";
export const ADD_WORKFLOW = "ADD_WORKFLOW";
export const UPDATE_WORKFLOW = "UPDATE_WORKFLOW";
export const DELETE_WORKFLOW = "DELETE_WORKFLOW";

export const getAllWorkflows = ({
  clientId,
  name = "",
  page = 1
}) => async dispatch => {
  try {
    dispatch({
      type: LOADING_WORKFLOW,
      payload: true
    });
    const result = await axios().get(
      `/workflows/clients/${clientId}?page=${page}&name=${name}`
    );
    dispatch({
      type: LOADING_WORKFLOW,
      payload: false
    });
    return dispatch({
      type: GET_ALL_WORKFLOWS,
      payload: result.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_WORKFLOW,
      payload: false
    });
    dispatch({
      type: GET_ALL_WORKFLOWS,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: ERROR_WORKFLOW,
      payload: error
    });
  }
};

export const getWorkflow = id => async dispatch => {
  try {
    dispatch({
      type: LOADING_WORKFLOW,
      payload: true
    });
    const result = await axios().get(`/workflows/${id}`);
    dispatch({
      type: LOADING_WORKFLOW,
      payload: false
    });
    dispatch({
      type: GET_WORKFLOW,
      payload: result.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_WORKFLOW,
      payload: false
    });
    dispatch({
      type: GET_WORKFLOW,
      payload: null
    });
    dispatch({
      type: ERROR_WORKFLOW,
      payload: error
    });
  }
};

export const addWorkflow = data => async dispatch => {
  try {
    dispatch({
      type: LOADING_WORKFLOW,
      payload: true
    });
    const result = await axios().post(`/workflows`, data);
    dispatch({
      type: ERROR_WORKFLOW,
      payload: null
    });
    dispatch({
      type: ADD_WORKFLOW,
      payload: result.data.data
    });
    dispatch({
      type: LOADING_WORKFLOW,
      payload: false
    });
  } catch (error) {
    dispatch({
      type: LOADING_WORKFLOW,
      payload: false
    });
    dispatch({
      type: ERROR_WORKFLOW,
      payload: error
    });
  }
};

export const updateWorkflow = ({ id, data }) => async dispatch => {
  try {
    dispatch({
      type: LOADING_WORKFLOW,
      payload: true
    });
    const result = await axios().put(`/workflows/${id}`, data);
    dispatch({
      type: LOADING_WORKFLOW,
      payload: false
    });
    dispatch({
      type: ERROR_WORKFLOW,
      payload: null
    });
    dispatch({
      type: UPDATE_WORKFLOW,
      payload: result.data.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_WORKFLOW,
      payload: false
    });
    dispatch({
      type: ERROR_WORKFLOW,
      payload: error
    });
  }
};

export const deleteWorkflow = id => async dispatch => {
  try {
    dispatch({
      type: LOADING_WORKFLOW,
      payload: true
    });
    const result = await axios().delete(`/workflows/${id}`);
    dispatch({
      type: LOADING_WORKFLOW,
      payload: false
    });
    dispatch({
      type: ERROR_WORKFLOW,
      payload: null
    });
    dispatch({
      type: DELETE_WORKFLOW,
      payload: result.status
    });
  } catch (error) {
    dispatch({
      type: DELETE_WORKFLOW,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: LOADING_WORKFLOW,
      payload: false
    });
    dispatch({
      type: ERROR_WORKFLOW,
      payload: error
    });
  }
};

export const resetPayload = type => dispatch => {
  dispatch({
    type: type,
    payload: null
  });
};
